import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-otm-form',
  templateUrl: './otm-form.component.html',
  styleUrls: ['./otm-form.component.scss']
})
export class OtmFormComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void { }

  goToApplication() {
    window.open('https://otmgtm-a563560.otmgtm.us-phoenix-1.ocs.oraclecloud.com/');
  }
}
